import { Observable, fromEvent, merge, timer } from 'rxjs';
import { filter, shareReplay, switchMap } from 'rxjs/operators';

export type ServerTimeProvider = () => Observable<Date>;

export function createHttpServerTime$(
    getServerTime$: ServerTimeProvider,
    periodMs: number
): Observable<Date> {
    const periodic$ = timer(0, periodMs);

    const visible$ = fromEvent(document, 'visibilitychange').pipe(
        filter(() => document.visibilityState === 'visible')
    );

    const online$ = fromEvent(window, 'online');

    return merge(periodic$, visible$, online$).pipe(
        switchMap(() => getServerTime$()),
        shareReplay({ bufferSize: 1, refCount: true })
    );
}
